export enum ReportTypes {
    UNKNOWN = 0,
    LISTINGS_REPORT = 1,
    DISTRIBUTION_TRACKING_REPORT = 2,
    PREMIER_INN_REPORT = 3,
}
